module.exports = __webpack_public_path__ + "static/media/awoolplanet_htu03.747c7080.gif";